import { useInfiniteQuery } from '@tanstack/react-query'
import { transactionsApi } from '@/api'

export const useGetPostedTransactions = () => {
  return useInfiniteQuery({
    queryKey: ['all_transaction'],
    queryFn: async ({ pageParam }) => transactionsApi.getTransactions('', '', pageParam),
    initialPageParam: '',
    getNextPageParam: lastPage => lastPage?.pageInfo?.endCursor,
    staleTime: 2 * 60 * 1000, // 2 minutes - match account summary for parity
    refetchOnWindowFocus: true,
    refetchOnMount: true, // Always refetch on mount to ensure parity with balance updates
  })
}
